import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { CoasVideoPreview } from "../utilities/youtubeVideo";
var ajaxCount = 0;
class videoImage {
    constructor() {
        this.initPageConfig();
    }
    initPageConfig() {
        // Cards slider
        if (document.querySelector(".abi-allepisodes-carousel")) {
            new Splide('.abi-allepisodes-carousel', {
                arrows: false,
                pagination: true,
                gap: 30,
                perPage: 3,
                padding: '0%',
                breakpoints: {
                    767: {
                        gap: 10,
                        perPage: 1,
                        padding: '0%',
                    },
                }
            }).mount();
        }
        // Init video component
        const videos = document.querySelectorAll(".abi__card-video");
        if (videos) {
            videos.forEach(video => {
                if (video) {
                    const videoId = video.getAttribute("id");
                    const containerVideo = new CoasVideoPreview(videoId);
                    containerVideo.onInit();
                }
            });
        }
    }
}
(function ($, Drupal, once) {
    $(document).on("click", ".abi__all-episodes-filters form .js-form-item label", function () {
        var _a;
        (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.classList.toggle("selected");
    });
    Drupal.behaviors.sliderAllEpisodes = {
        attach: function (context, settings) {
            const buttonSeason = document.querySelectorAll(".abi__all-episodes-filters form ul li a");
            if (buttonSeason) {
                buttonSeason.forEach(button => {
                    button.addEventListener('click', () => {
                        ajaxCount = 0;
                    });
                });
            }
            if (window.innerWidth < 1024) {
                const activeButton = document.querySelector(".abi__all-episodes-filters form ul li a.bef-link--selected");
                const labelSelector = document.querySelector(".abi__all-episodes-filters form .js-form-item label");
                if (labelSelector && activeButton) {
                    labelSelector.innerHTML = `${activeButton.textContent}`;
                }
            }
            $(context).ajaxStop(function () {
                ajaxCount += 1;
                if (ajaxCount == 1) {
                    new videoImage();
                }
            });
        },
    };
})(jQuery, Drupal, once);
